import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Utils */
import {convertPriceToDecimal} from '../../../../modules/homePageComponents/homePageComponentsUtils'

/* Styles */
import s from './product-card.scss'

const ProductPrice = memo(({onSalePrice, originalPrice, isDiscounted, showOriginalPrice}) => (
  <div className={s.priceContainer}>
    <div className={isDiscounted && showOriginalPrice ? s.price : cx(s.price, s.pricediscounted)}>
      {`${convertPriceToDecimal(onSalePrice)} TL`}
    </div>
    {isDiscounted && showOriginalPrice && <div aria-hidden='true' className={s.originalPrice}>{`${convertPriceToDecimal(originalPrice)} TL`}</div>}
  </div>
))

ProductPrice.propTypes = {
  isDiscounted: PropTypes.bool,
}

export default ProductPrice
